/* eslint-disable @typescript-eslint/no-explicit-any */
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import axiosInstance from '@/lib/axiosInstance'

// Type declarations for global window object
declare global {
    interface Window {
        Echo: Echo<any>;
        Pusher: typeof Pusher;
    }
}

let echo: Echo<any> | null = null;
const isDev = process.env.NODE_ENV === 'development';


if (typeof window !== 'undefined' && !isDev) {
    window.Pusher = Pusher;

    echo = new Echo({
        broadcaster: 'reverb',
        key: process.env.NEXT_PUBLIC_REVERB_APP_KEY,
        wsHost: process.env.NEXT_PUBLIC_REVERB_HOST,
        wsPort: 443,
        wssPort: 443,
        forceTLS: true,
        enabledTransports: ['ws', 'wss'],
        authorizer: (channel: any) => {
            return {
                authorize: (socketId: any, callback: any) => {
                    axiosInstance
                        .post('/broadcasting/auth', {
                            socket_id: socketId,
                            channel_name: channel.name,
                        })
                        .then((response: any) => {
                            callback(false, response.data);
                        })
                        .catch((error: any) => {
                            callback(true, error);
                        });
                },
            };
        },
    });
}

export default echo;